import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {confirmAlert} from "react-confirm-alert";
import Access from "constants/Access";
import {ListItemText} from "@material-ui/core";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";
import LaunchIcon from '@material-ui/icons/Launch';
import {mark4473Printed, recordUnprinted4473IfNeeded} from "utils/unprinted4473Reminder";

const DISPOSITION_RECEIPT_FORM_ID = 32;

const ATF_4473_FORM_IDS = [1, 5, 7, 8, 14, 16, 21, 22, 24, 25];
const RI060_SIGNATURE_OPTIONS = [
	{ key: "print_both", label: "Print both (with and without signature)" },
	{ key: "print_signature", label: "Print signature only" },
	{ key: "no_signature", label: "No signature" }
];
const DEFAULT_RI060_SIGNATURE_PREFERENCE = "print_signature";
class Disposition extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.question = null;
		this.state.question_binary_id = null;
		this.state.signatures = [];
		this.state.transaction_signatures = [];
		this.state.location = null;
		this.state.location_binary_id = null;
		this.state.toggleForm = false;
		this.state.ri060SignatureModalOpen = false;
		this.state.ri060SignaturePreference = DEFAULT_RI060_SIGNATURE_PREFERENCE;
		this.state.ri060SetupError = '';
		this.state.ri060Locking = false;
		this.state.anchorGen = null;
	}

	componentWillUnmount() {
		recordUnprinted4473IfNeeded(this.props.match.params.id);
	}

	updateData = (id, binary_id, signatures, transaction_signatures, location, location_binary_id) => {
		this.setState({
			question: id,
			question_binary_id: binary_id,
			signatures: signatures,
			transaction_signatures: transaction_signatures,
			location: location,
			location_binary_id: location_binary_id
		})
	};

	toggle = (name) => () => {
		this.handleClose();
		this.setState({[name]: !this.state[name]});
	};

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	sendCleo = (form) => async () => {
		this.handleClose();
		confirmAlert({
			title: 'Send to CLEO',
			message: 'Do you want to send this to CLEO?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true})
						await this.printPdf(form, true)();
						this.setState({loading: false})
					}
				},
				{
					label: 'No',
					onClick: async () => {
						this.setState({loading: true})
						await this.printPdf(form, false)();
						this.setState({loading: false})
					}
				}
			]
		});
	};


	printPdf = (form, sendEmail) => async () => {
		this.handleClose();
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.object.send_email = sendEmail;
		model.object.location = this.state.location;
		model.object.location_binary_id = this.state.location_binary_id;
		if (form === 26 && this.state.ri060SignaturePreference) {
			model.object.ri060_signature_preference = this.state.ri060SignaturePreference;
		}
		model.parent = this.props.match.params.id;

		let createdForm;
		try {
			createdForm = await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return null;
		}

		this.setState({tab: 'forms'})

		this.refreshPage();
		return createdForm;
	};

	generatedForm = () => {
		this.refreshPage();
		this.setState({tab: 'forms'});
	};

	/**
	 *
	 */
	handleAfterP12Save = () => {
		this.refreshPage();
	}

	handleFormPrintClick = (formObject) => {
		const formName = formObject && formObject.forms ? formObject.forms.name : '';
		const formFile = formObject && formObject.forms ? formObject.forms.file : '';
		const is4473Form = ATF_4473_FORM_IDS.includes(formObject.form) ||
			String(formName).includes('4473') ||
			String(formFile).includes('combined');

		if (is4473Form) {
			mark4473Printed(this.props.match.params.id);
		}
	}

	toggleForm = () => {
		this.setState({toggleForm: !this.state.toggleForm})
		this.handleClose();
	};

	handleSendToPOS = async () => {
		let uploadModel = new API.BuildClass(Types.Point_Of_Sales._name, 'POST_CHECKOUT');
		uploadModel.object.pkey = this.props.match.params.id;
		let data = await uploadModel.submit(null, 'POST_CHECKOUT');
	}



	openRi060SignatureModal = () => {
		this.setState({
			anchorGen: null,
			ri060SignatureModalOpen: true,
			ri060SetupError: '',
			ri060SignaturePreference: DEFAULT_RI060_SIGNATURE_PREFERENCE,
		});
	};

	closeRi060SignatureModal = () => {
		this.setState({
			ri060SignatureModalOpen: false,
			ri060SetupError: '',
			ri060Locking: false
		});
	};

	handleRi060Generate = async () => {
		const preference = this.state.ri060SignaturePreference || DEFAULT_RI060_SIGNATURE_PREFERENCE;

		this.setState({
			ri060SignatureModalOpen: false,
			ri060Locking: true,
			ri060SetupError: ''
		}, async () => {
			const created = await this.printPdf(26, false, preference)();

			if (!created) {
				this.setState({
					ri060SignatureModalOpen: true,
					ri060Locking: false,
					ri060SetupError: 'Failed to generate Michigan RI-060 form.'
				});
				return;
			}

			this.setState({
				ri060SignatureModalOpen: false,
				ri060SetupError: '',
				ri060Locking: false
			});
		});
	};

	render() {
		const {anchorGen, loading} = this.state;

		let currentActiveLocation = this.props.rootState.locations.find(loc =>
			loc.pkey === this.state.location && loc.binary_id === this.state.location_binary_id
		);
		const hasDispositionReceiptModule = currentActiveLocation?.has_disposition_receipt_module;
		let breadcrumbs = [
			{
				name: 'Dashboard',
				url: this.props.kioskMode ? `/dispositions/${this.props.match.params.id}` : '/',
				icon: 'dashboard',
			},
			{
				name: 'Dispositions',
				url: this.props.kioskMode ? `/dispositions/${this.props.match.params.id}` : '/dispositions',
				icon: 'download',
			},
			{
				name: this.state.name,
				url: `/dispositions/${this.props.match.params.id}`,
				icon: 'file-text-o',
			}
		];

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}
				override_children={<Button
										size={"sm"}
										color="success"
										aria-owns={anchorGen ? 'anchorGen' : null}
										aria-haspopup="true"
										onMouseDown={this.handleSendToPOS}
										style={{marginRight: "10px"}}
									>
										<LaunchIcon/>&nbsp;&nbsp;Send to POS Checkout
									</Button>}
				>
					{!this.props.kioskMode && <Button onClick={()=>this.props.history.push('/dispositions/enics_statuses')} size="sm" color="primary">
						<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Assisted LEEP
					</Button>}
					{!this.props.kioskMode && <Button
						size={"sm"}
						color="primary"
						aria-owns={anchorGen ? 'anchorGen' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorGen')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Form
					</Button>}
					<Menu
						id="anchorGen"
						anchorEl={anchorGen}
						open={Boolean(anchorGen)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						{hasDispositionReceiptModule && <MenuItem onClick={this.printPdf(DISPOSITION_RECEIPT_FORM_ID, false)}>
							<ListItemText inset primary="Disposition Receipt (Customer Copy)"/>
						</MenuItem>}
						<MenuItem onClick={this.printPdf(21, false)}>
							<ListItemText inset primary="ATF 4473 (Disposition Form)"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(2, false)}>
							<ListItemText inset primary="ATF 3310.12 (Multiple Sale Form of Certain Rifles)"/>
						</MenuItem>
						<MenuItem onClick={this.sendCleo(3)}>
							<ListItemText inset primary="ATF 3310.4 (Multiple Sale Form of Pistols/Revolvers)"/>
						</MenuItem>
						{(this.props.rootState.hasMichiganRIModule || this.props.rootState.hasRIComboModule) && <MenuItem onClick={this.openRi060SignatureModal}>
						<ListItemText inset primary="Michigan RI-060 Form Generation"/>
						</MenuItem>
						}

						{this.props.rootState.hasNYP12Module && <MenuItem onClick={() => this.toggleForm()}>
							<ListItemText inset primary="Generate P12 Form"/>
						</MenuItem>
						}

						{currentActiveLocation?.has_ct_dps_module && <MenuItem onClick={this.printPdf(28, false)}>
							<ListItemText inset primary="Generate CT DPS67C Form"/>
						</MenuItem>}

						{currentActiveLocation?.has_dr_7602_module && <MenuItem onClick={this.printPdf(30, false)}>
							<ListItemText inset primary="Generate Colorado DR 7602 Form"/>
						</MenuItem>}

					</Menu>
					{!this.props.kioskMode && <Button onClick={this.toggle('modalUpload')} size="sm" color="primary">
						<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Attach File
					</Button>}
				</Framework.Components.PageBar>

				<Modal isOpen={this.state.ri060SignatureModalOpen} toggle={this.closeRi060SignatureModal} size="sm">
					<ModalHeader toggle={this.closeRi060SignatureModal}>
						Michigan RI-060 Signature Preference
					</ModalHeader>
					<ModalBody>
						{this.state.ri060SetupError && (
							<div className="alert alert-danger">{this.state.ri060SetupError}</div>
						)}
						<FormGroup>
							<Label><strong>Customer Signature</strong></Label>
							<Input
								type="select"
								value={this.state.ri060SignaturePreference}
								onChange={(e) => this.setState({ ri060SignaturePreference: e.target.value })}
							>
								{RI060_SIGNATURE_OPTIONS.map((option) => (
									<option key={option.key} value={option.key}>{option.label}</option>
								))}
							</Input>
						</FormGroup>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={this.closeRi060SignatureModal} disabled={this.state.ri060Locking}>
							Cancel
						</Button>
						<Button color="primary" onClick={this.handleRi060Generate} disabled={this.state.ri060Locking}>
							{'Continue'}
						</Button>
					</ModalFooter>
				</Modal>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Disposition" value={'details'}/>
					<Tab label="Signatures" value={'signatures'}/>
					<Tab label="Eligibility" value={'eligibility'}/>
					<Tab label="Forms" value={'forms'}/>
					<Tab label="Uploaded Files" value={'upload'}/>
					{ this.props.userAccess <= Access.Manager && <Tab label="Change Log" value={'logs'}/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.DispositionEdit
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						generatedForm={this.generatedForm}
						toggleForm={this.state.toggleForm}
						updateName={this.updateName}
						updateData={this.updateData}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						userAccess={this.props.userAccess}
						question = {this.state.question}
					/>
				</div>
				{this.state.tab === 'signatures' &&
				<Objects.DispositionSignatures
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					signatures={this.state.signatures}
					transactionSignatures={this.state.transaction_signatures}
				/>}
				{this.state.tab === 'eligibility' &&
				<Objects.DispositionQuestions
					id={this.state.question}
					binary_id={this.state.question_binary_id}
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
				/>}
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Transactions_Collections_Forms._name}
					url="/transactions/[PARENT]/collections_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					afterSave={this.handleAfterP12Save}
					onPrintFormClick={this.handleFormPrintClick}

				/>}
				{this.state.tab === 'upload' &&
				<Collections.TransactionUploads
					parent={this.props.match.params.id}
					// forForm={Types.Transactions_Collections_Forms._name}
					// url="/transactions/[PARENT]/collections_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' && this.props.userAccess <=Access.Manager&&
				<Collections.LogsDispositions
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Attached File"
					object={Objects.TransactionUpload}
					history={this.props.history}
					toggle={this.state['modalUpload']}
					reportClose={this.reportClose('modalUpload')}
					afterSave={this.handleAfterSave}
					url="dispositions"
					objectProps={{
						// type: this.props.type,
						// handleTabChange: this.props.handleTabChange
					}}
				/>


				{/*<UniversalModalOverride*/}
				{/*	locations={this.props.locations}*/}
				{/*	states={this.props.states}*/}
				{/*	name="Attached File"*/}
				{/*	object={Objects.FormP12}*/}
				{/*	history={this.props.history}*/}
				{/*	toggle={this.state['formP12']}*/}
				{/*	reportClose={this.reportClose('formP12')}*/}
				{/*	afterSave={this.handleAfterSave}*/}
				{/*	url="dispositions"*/}
				{/*	size="xl"*/}
				{/*/>*/}
			</div>
		);
	}
};


export default Framework.Components.withRootState(Disposition);
